import Vue from "vue";
import VueViewer from "v-viewer";
import "viewerjs/dist/viewer.css";

Vue.use(VueViewer);
